import React from "react";
import ReactDOM from "react-dom/client";
import "./theme.css";
import AppRoot from "./AppRoot";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<AppRoot />);
